import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/**
 * Factory for TranslateModule.forRoot() in AppModule.
 *
 * Lives in its own file rather than alongside CommonComponentsModule: importing
 * any symbol from common-components.module.ts pulls that module — and its ~88
 * declarations and third-party imports — into the eager graph, which is exactly
 * what keeping the app shell out of the initial bundle is meant to avoid.
 */
export function createTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
